// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + "home" + ".js?v=1.8.2_1761289754269";
};